import { render, staticRenderFns } from "./bid-project-list.html?vue&type=template&id=5e20d3a3&scoped=true&external"
import script from "./bid-project-list.js?vue&type=script&lang=js&external"
export * from "./bid-project-list.js?vue&type=script&lang=js&external"
import style0 from "./bid-project-list.scss?vue&type=style&index=0&id=5e20d3a3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e20d3a3",
  null
  
)

export default component.exports